import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  GET_ACTOR_FILTERS,
  SEARCH_ACTOR_FILTERS,
} from '@control-front-end/common/constants/graphActors';
import SelectEntityField from '../SelectEntityField';

/**
 * Выбор фильтров акторов
 */
function SelectActorFilters(props) {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState([]);

  const getData = () => {
    dispatch({
      type: GET_ACTOR_FILTERS.REQUEST,
      callback: (data) => setFilters(data),
    });
  };

  const clearData = () => {
    setFilters([]);
  };

  /**
   * Обработка поискового запроса
   */
  const handleSearch = (query) => {
    if (!query.length) {
      getData();
      return;
    }
    if (query.length < 2) return;
    dispatch({
      type: SEARCH_ACTOR_FILTERS.REQUEST,
      payload: query,
      callback: (data) => setFilters(data),
    });
  };

  return (
    <SelectEntityField
      {...props}
      objType="actorFilter"
      list={filters}
      onSearch={handleSearch}
      onFocus={() => getData()}
      onBlur={() => clearData()}
      onScroll={() => {}}
    />
  );
}

export default SelectActorFilters;
